// named export (recommended)

export const PERSONAL_CHAUFFEUR_page = {
    roiInvestorBenefits: {
        sectionId: "Make journey comfortable with",
        title: "More Than a Driver, Your Time, Your Comfort, Your Style",
        image: {
            src: "https://demo-rsllifestyle.s3.us-east-1.amazonaws.com/images/bannerImage/personal-chauffer-service-banner.png",
            alt: " Hands offering coins"
        },
        button: { text: "Book Your Ride", link: "#", endIconSrc: true },
        bgcolor: "#fff",
    },
    ourPackage: {
        sectionId: "Make journey comfortable with",
        title: "Our Packages",
        subtitle: "Looking for something?",
        image: {
            src: "/img/personal-chauffeur/section2.svg",
            alt: " Hands offering coins"
        },
        pricingData: [
            {
                "plan": "Basic plan",
                "price": "$20",
                "per": "/month",
                "billingNote": "Billed annually.",
                "icon": "/img/personal-chauffeur/icon.svg",
                "features": [
                    "Access to all basic features",
                    "Basic reporting and analytics",
                    "Up to 10 individual users",
                    "20GB individual data each user",
                    "Basic chat and email support"
                ],
                "ctaText": "Get started"
            },
            {
                "plan": "Standard plan",
                "price": "$20",
                "per": "/month",
                "billingNote": "Billed annually.",
                "icon": "/img/personal-chauffeur/icon.svg",
                "features": [
                    "Access to all basic features",
                    "Basic reporting and analytics",
                    "Up to 10 individual users",
                    "20GB individual data each user",
                    "Basic chat and email support"
                ],
                "ctaText": "Get started"
            },
            {
                "plan": "Premium plan",
                "price": "$20",
                "per": "/month",
                "billingNote": "Billed annually.",
                "icon": "/img/personal-chauffeur/icon.svg",
                "features": [
                    "Access to all basic features",
                    "Basic reporting and analytics",
                    "Up to 10 individual users",
                    "20GB individual data each user",
                    "Basic chat and email support"
                ],
                "ctaText": "Get started"
            }
        ],
        button: { text: "Book Now", link: "#" },
        bgcolor: "#fff",
    },
    carToInvest: {
        sectionId: "Make journey comfortable with",
        title: "Benefits Of Collaborating With RSL",
        subtitle:
            "Make journey comfortable with",
        image: {
            src: "/img/investments/collaborate/benefits.svg",
            alt: " Hands offering coins"
        },
        button: { text: "Let's work together", link: "#" },
        bgcolor: "#fff",
    },
    communicationChannel: {
        sectionId: "communicationChannel",
        image: {
            src: "/images/bannerImage/rsl_super_app.svg",
            alt: "RSL SUPER APP"
        }
    }
}